// Enums
export const enums = {
  // Steps
  SET_AVAILABILITY: "SET_AVAILABILITY",
  PRICING: "PRICING",
  REVIEW_PUBLISH: "REVIEW_PUBLISH",

  // Session types
  ONE_TIME: "ONE_TIME",
  OCCUR_ON_SELECTED_DATES: "OCCUR_ON_SELECTED_DATES",
  OCCUR_ON_SELECTED_DAYS_OF_WEEK: "OCCUR_ON_SELECTED_DAYS_OF_WEEK",
};

const labels = {
  [enums.SET_AVAILABILITY]: "Product Details",
  [enums.PRICING]: "Pricing",
  [enums.REVIEW_PUBLISH]: "Review & Publish",

  // Session Types
  [enums.ONE_TIME]: "One Time",
  [enums.OCCUR_ON_SELECTED_DATES]: "Occur On Selected Dates",
  [enums.OCCUR_ON_SELECTED_DAYS_OF_WEEK]: "Occur on Selected Days of the Week",
};

//TODO: To fix label mapping
export const constants = {
  steps_conf: [
    labels[enums.SET_AVAILABILITY],
    labels[enums.PRICING],
    labels[enums.REVIEW_PUBLISH],
  ],
  session_types: {
    [enums.ONE_TIME]: 1,
    [enums.OCCUR_ON_SELECTED_DATES]: 5,
    [enums.OCCUR_ON_SELECTED_DAYS_OF_WEEK]: 6,
  },
  initialValues: {
    [enums.OCCUR_ON_SELECTED_DAYS_OF_WEEK]: [1, 2, 3, 4, 5, 6, 7],
  },
};

export const webinarValidations = {
  title: {
    min: {
      value: 3,
      label: "Title must be atleast 3 characters",
    },
    max: {
      value: 100,
      label: "Title must be atmost 100 characters",
    },
  },
};

export const pages = {
  details: 0,
  pricing: 1,
  review: 2,
};

export const WEBINAR_LEARN_MORE_HREFS = {
  WEBINAR_CREATION:
    "https://support.exlyapp.com/en/support/solutions/articles/84000392229-live-webinars-on-exly-how-to-create-and-share-them-",
};
